import React from 'react';
import { Plus } from 'lucide-react';
import { useInvoiceStore } from '../stores/invoiceStore';
import { useTranslation } from '../hooks/useTranslation';
import { motion } from 'framer-motion';
import { useInvoiceHasContent } from '../stores/selectors';

export const NewInvoiceButton: React.FC = () => {
  const { t } = useTranslation();
  const currentInvoice = useInvoiceStore((state) => state.currentInvoice);
  const { resetCurrentInvoice } = useInvoiceStore();
  const hasContent = useInvoiceHasContent();

  const handleNewInvoice = () => {
    // Only show confirmation if we're editing a saved invoice or have unsaved changes
    const needsConfirmation = currentInvoice.status === 'concept' && hasContent;

    if (!needsConfirmation || window.confirm('Start a new invoice? Any unsaved changes will be lost.')) {
      resetCurrentInvoice();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Only render if we have an active invoice with state 'saved'
  if (currentInvoice.status == 'concept') {
    return null;
  }

  return (
    <motion.button
      onClick={handleNewInvoice}
      className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 px-4 py-2.5 flex items-center space-x-2 group"
      whileHover={{ y: -1 }}
      whileTap={{ y: 1 }}
    >
      <Plus className="w-4 h-4 text-gray-400 group-hover:text-primary-500 transition-colors" />
      <span className="text-sm font-medium text-gray-700 group-hover:text-gray-900 transition-colors">
        {t('actions.new')}
      </span>
    </motion.button>
  );
}; 